import { render, staticRenderFns } from "./TheLotteryForm.vue?vue&type=template&id=67f5a4d0&scoped=true"
import script from "./TheLotteryForm.vue?vue&type=script&lang=js"
export * from "./TheLotteryForm.vue?vue&type=script&lang=js"
import style0 from "./TheLotteryForm.vue?vue&type=style&index=0&id=67f5a4d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f5a4d0",
  null
  
)

export default component.exports